export default __webpack_public_path__ + "97faaf468032d5f4883fad22472ddbc3.svg";